import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'primeng';
import { PrimengModule } from 'src/app/primeng/primeng.module';
import { PatientRefundComponent } from './patient-refund/patient-refund.component';
import { PatientaccountsComponent } from './patientaccounts/patientaccounts.component';
import { DoctoraccountsComponent } from './doctoraccounts/doctoraccounts.component';
import { InvoiceModule } from '../../../shared/invoice/invoice.module';

@NgModule({
    declarations: [
        PatientRefundComponent,
        PatientaccountsComponent,
        DoctoraccountsComponent
    ],
    imports: [CommonModule, PrimengModule, SharedModule, InvoiceModule]
})
export class AccountsModule {}
